import {UserMeClipType} from '../../core/entities/clip/constants';
import {ClipFavoriteButtonForColumn} from '../../features/clip/components/ClipList/ClipFavoriteButtonForColumn';
import {ClipFavoriteButtonForReport} from '../../features/clip/components/ClipList/ClipFavoriteButtonForReport';
import type {IClipContentProps} from '../../features/clip/components/ClipList/ClipListInterfaces';

export function getFavoriteButtonComponent(
  clipType: UserMeClipType,
): React.FC<IClipContentProps> {
  const componentMapping = {
    [UserMeClipType.COLUMN]: ClipFavoriteButtonForColumn,
    [UserMeClipType.COMPANY_COLUMN]: ClipFavoriteButtonForColumn,
    [UserMeClipType.SELECTION_REPORT]: ClipFavoriteButtonForReport,
    [UserMeClipType.ENTRY_SHEET]: ClipFavoriteButtonForReport,
  };

  return componentMapping[clipType];
}
